import { CascadiaColor } from "@certn/cascadia-tokens";

import { _Button } from "./_Button";
import { CascadiaButtonProps } from "./types";

interface Props extends CascadiaButtonProps {
  hoverFill?: CascadiaColor;
}

export function GhostButton(props: Props) {
  const { hoverFill = "background-ghost-hover", ...buttonProps } = props;

  return (
    <_Button
      color="text-base"
      focusStyle="focus-action"
      hoverFill={hoverFill}
      iconColor="icon-base"
      loaderColor="icon-success"
      {...buttonProps}
    />
  );
}
